
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonConstants } from '../../../../../common/constants/common-constants';
import { RequestsProposedSolutionListEntity } from '../model/requestproposedsolutionbasicinfo';
import { Observable } from 'rxjs';


@Injectable()
export class ProposedSolutionService {
    constructor(public http: HttpClient) {
    }

    // function call to fetch proposedSolution list
    public getProposedSolutionList(requestNumber: number): Observable <RequestsProposedSolutionListEntity> {
        return this.http.get<RequestsProposedSolutionListEntity>(CommonConstants.SERVICE_VERSION_PATH_V1 +
            '/customer/requests/' + requestNumber + '/proposedSolution');
    }

    public resolveRequestThroughProposedSolution(requestNumber: number, kbaId: number) {
        return this.http.put(CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/requests/'
        + requestNumber + '/' + kbaId + '/resolve', null);
    }
}
